import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '@auth/services/auth.service';
import { catchError, map, of } from 'rxjs';

/**
 * A guard that checks if a user is authenticated before allowing access to a route.
 *
 * @param route The route that is being activated.
 * @param state The state of the router.
 * @returns An observable that emits true if the user is authenticated, otherwise false.
 */
export const AuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.user()) {
    return true;
  }

  return authService.loadUser().pipe(
    map(user => {
      if (user) {
        return true;
      } else {
        router.navigate(['/login']);
        return false;
      }
    }),
    catchError(() => {
      router.navigate(['/login']);
      return of(false);
    })
  );
};
